import React from 'react';

export type BreakTypeInfo = {
  Id: string;
  Name: string;
  flair__Icon__c: string | null;
  flair__Custom_Emoji__c: string | null;
};

type BreakTypeIconProps = {
  icon: string | null;
  customEmoji: string | null;
  name: string;
  size?: number;
};

const BREAK_TYPE_ICON_MAP: Record<string, string> = {
  lunch: '🍽️',
  coffee: '☕',
  smoke: '🚬',
  breakfast: '🥐',
  default: '⏸️',
};

const getBreakTypeEmojiText = (
  icon: string | null,
  customEmoji: string | null,
): string => {
  if (customEmoji) {
    return customEmoji;
  }
  return (
    BREAK_TYPE_ICON_MAP[icon ?? 'default'] ?? BREAK_TYPE_ICON_MAP['default']
  );
};

const BreakTypeIcon: React.FC<BreakTypeIconProps> = ({
  icon,
  customEmoji,
  name,
  size = 16,
}) => {
  const emoji = getBreakTypeEmojiText(icon, customEmoji);
  return (
    <span
      className="d-inline-flex align-items-center justify-content-center"
      style={{ fontSize: size, lineHeight: 1 }}
      title={name}>
      {emoji}
    </span>
  );
};

export const getBreakTypeName = (
  breakTypes: BreakTypeInfo[],
  breakTypeId?: string | null,
): string | undefined => {
  if (!breakTypeId) return undefined;
  return breakTypes.find((bt) => bt.Id === breakTypeId)?.Name;
};

export default BreakTypeIcon;
